import React, { createContext, useContext, useState, useEffect } from 'react';

const HelpContext = createContext();

export const useHelp = () => {
  const context = useContext(HelpContext);
  if (!context) {
    throw new Error('useHelp must be used within a HelpProvider');
  }
  return context;
};

export const HelpProvider = ({ children }) => {
  const [isHelpMode, setIsHelpMode] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState(null);

  // Auto-rotation des tooltips toutes les 3 secondes
  useEffect(() => {
    if (isHelpMode) {
      const interval = setInterval(() => {
        setActiveTooltip((prev) => {
          if (prev === null) return 0;
          return (prev + 1) % 8; // 8 menus dans la navigation
        });
      }, 3000); // Change toutes les 3 secondes

      return () => clearInterval(interval);
    }
  }, [isHelpMode]);

  const toggleHelpMode = () => {
    if (isHelpMode) {
      setIsHelpMode(false);
      setActiveTooltip(null);
    } else {
      setIsHelpMode(true);
      // Commencer par le premier tooltip
      setActiveTooltip(0);
    }
  };

  const nextTooltip = () => {
    setActiveTooltip((prev) => {
      if (prev === null) return 0;
      return (prev + 1) % 8; // 8 menus dans la navigation
    });
  };

  const value = {
    isHelpMode,
    toggleHelpMode,
    activeTooltip,
    nextTooltip,
  };

  return (
    <HelpContext.Provider value={value}>
      {children}
    </HelpContext.Provider>
  );
}; 